import DirectoriesOpen from './DirectoriesOpen/DirectoriesOpen'
import classes from './Directories.module.scss'

const Directories = () => {
    return (
        <div className={classes.projectsContainer}>
            <DirectoriesOpen />
        </div>
    )
}

export default Directories